import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, Optional, TransferState } from '@angular/core';
import { NCONF } from '@candyland/angular/shared/model-nmo';
import { AppComponent } from './app.component';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AngularSharedUiNmoModule } from '@candyland/angular/shared/ui-nmo';
import { VideoContainerV2Module } from '@candyland/angular/shared/ui-nmo/lazy-video';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { CustomPlayerComponent } from './pages/custom-player/custom-player.component';
import { JwplayerComponent } from './pages/custom-player/jwplayer/jwplayer.component';
import { HomeComponent } from './pages/home/home.component';
import {
  AngularSharedUtilNmoModule,
  runtimeConfigFactory,
  TT_ASSETS_ENDPOINT,
  TT_COM_PROCESSING_ENDPOINT,
} from '@candyland/angular/shared/util-nmo';
import { RadiantPlayerComponent } from './pages/custom-player/radiant-player/radiant-player.component';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeDeAt from '@angular/common/locales/de-AT';

registerLocaleData(localeDeAt);

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'custom-player/:mediaId',
    component: CustomPlayerComponent,
  },
];

@NgModule({
  declarations: [AppComponent, CustomPlayerComponent, JwplayerComponent, HomeComponent, RadiantPlayerComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, {}),
    AngularSharedUiNmoModule,
    AngularSharedUtilNmoModule,
    HammerModule,
    VideoContainerV2Module,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-AT' },
    {
      provide: TT_ASSETS_ENDPOINT,
      useFactory: runtimeConfigFactory('TT_S3_URL_PREFIX', environment.tt_s3_url_prefix),
      deps: [TransferState, [new Optional(), NCONF]],
    },
    {
      provide: TT_COM_PROCESSING_ENDPOINT,
      useFactory: runtimeConfigFactory('TT_COM_PROCESSING_ENDPOINT', environment.tt_com_processing_endpoint),
      deps: [TransferState, [new Optional(), NCONF]],
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
})
export class AppModule {}
